/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import objectHash from 'object-hash';

/**
 * @private
 * @typedef {object | string | number | boolean | null} NotUndefined
 */

/**
 * Třídá pro hashování informací určených ke generování otisku zařízení.
 */
export default class FingerprintHasher {
  /**
   * Hashuje JavaScriptovou hodnotu.
   * @param {NotUndefined | NotUndefined[]} value Hodnota, která se má hashovat.
   * @returns {string} Řetězec hexadecimálních číslic.
   */
  hashObject(value) {
    return objectHash(value, {
      algorithm: 'sha1',
      encoding: 'hex',
      // Nezahrnují se funkce.
      respectFunctionNames: false,
      respectFunctionProperties: false,
      // Nezahrnují se speciální vlastnosti jako `prototype` apod.
      respectType: false
    });
  }
}
